import { render } from "./BlogMagentoCodeReview.vue?vue&type=template&id=35f58cda"
import script from "./BlogMagentoCodeReview.vue?vue&type=script&lang=js"
export * from "./BlogMagentoCodeReview.vue?vue&type=script&lang=js"

import "./BlogMagentoCodeReview.vue?vue&type=style&index=0&id=35f58cda&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__